//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const AccessibleRedirectNoPublicTenant: FeatureFlag = {"Id":"AccessibleRedirectNoPublicTenant","Label":"(KILL)[10.27]AccessibleRedirectNoPublicTenant","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. When active, Home/Index?redirectToAccessible=true returns Forbid/redirects to SSO login (using the found tenant's route prefix) instead of throwing when no descendant tenant grants public access.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
